@if (displayLabel) {
  <label
    soho-label
    [required]="required$ | async"
    [attr.for]="id"
    lm-label
    [layoutField] = "field"
    [lmColumnLayoutInfo]="lmColumnLayoutInfo"
    [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
    [layoutInfo]="layoutInfo"
    [personalize]="personalize && !field?.label?.textStyle?.color"
    [isCompoundFieldMember]="isCompoundFieldMember"
    lm-text-style
    [textStyle]="field?.label?.textStyle"
    [recalculateStyles]="triggerValueChange | async"
    >
    {{triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields}}
    <ng-container *ngTemplateOutlet="mouseOverTextTemplate"></ng-container>
  </label>
}
@switch (displayType) {
  @case (layoutDisplayType.READ_ONLY) {
    @if (largeImageIs) {
      <a href="javascript:void(0);" (click)="openLargeImage(largeImageIsInfo)" class="lm-large-image-is-link">
        <img #fileImage
          [attr.id]="id"
          class="image-auto"
          [ngStyle]="{ 'height.px': isSmartPhone ? 'auto' : imageHeight + 'px', 'width.px' : imageWidth }"
          [style.cursor]="this.field?.linkNavigation ? 'pointer' : ''"
          [src]="imageUrl | async"
          soho-alert
          alt="{{imageAltText}}"
          (click)="onClickEvent($event)"
          [attr.tabindex]="isInAccessibilityMode ? 0 : null"
          [attr.aria-describedby]="fieldDescriptionId"
          />
        </a>
    } @else {
      @if (foreGroundText && (missingImage | async)) {
        <span
          [attr.id]="id"
          class="{{bgColorClass}}"
          [attr.tabindex]="isInAccessibilityMode ? 0 : null"
          [ngStyle]="{ 'height.px': isSmartPhone ? 'auto' : imageHeight + 'px', 'width.px' : imageWidth, 'font-size.px': imageHeight / 4 }"
          soho-context-menu
          [autoFocus]="true"
          [menu]="menuId"
          trigger="click"
          (beforeopen)="onBeforeOpen()"
          soho-alert
          soho-input-validate
          (error)="onError($event)"
          (valid)="onValid($event)">
          {{foreGroundText}}
        </span>
      } @else {
        <img #fileImage
          [attr.id]="id"
          class="image-auto"
          [ngStyle]="{ 'height.px': isSmartPhone ? 'auto' : imageHeight + 'px', 'width.px' : imageWidth }"
          [style.cursor]="this.field?.linkNavigation ? 'pointer' : ''"
          [src]="imageUrl | async"
          soho-alert
          alt="{{imageAltText}}"
          (click)="onClickEvent($event)"
          [attr.tabindex]="isInAccessibilityMode ? 0 : null"
          [attr.aria-describedby]="fieldDescriptionId"
          />
      }
    }
  }
  @case (layoutDisplayType.PLAIN) {
    <div
      [ngClass]="{
        'container': true,
        'lm-missing-image': missingImage,
        'lm-random-bg': isRandomBackground,
        'lm-foreground-text': isForeGroundText
      }"
      [ngStyle]="{ 'height.px': isSmartPhone ? 'auto' : imageHeight + 'px', 'width.px' : imageWidth }"
      lm-field-options
      [hasContextMenu]="insertContextMenu"
      [ajaxCallbackFunction]="onBeforeContextMenuOpen"
      [contextMenuEventFunction]="contextMenuClicked"
      [buttonId]="fieldOptionsId"
      [fieldOptionsLabel]="fieldOptionsLabel | translate : foreGroundText || fieldNameForOptionsMenu"
      [isInAccessibilityMode]="isInAccessibilityMode"
      [displayFieldOptions]="displayFieldOptions"
      [disableFieldOptions]="disableFieldOptions"
      [fieldAutomationId]="fieldAutomationId"
      soho-tooltip
      [popover]="true"
      [title]="popoverTitle"
      [placement]="'right'"
      [trigger]="'click'"
      (contextmenu)="onContextMenu($event)"
      (focusin)="onFieldFocus($event)"
      (focusout)="onFieldBlur($event)"
      >
      @if (foreGroundText && (missingImage | async)) {
        <!--        [ngStyle]="{'height.px': lines ? (lines * 20) : 100, 'width.px': lines ? (lines * 20) : 100 }"-->
        <span
          [attr.id]="id"
          class="{{bgColorClass}}"
          [attr.tabindex]="isInAccessibilityMode ? 0 : null"
          [ngStyle]="{ 'height.px': isSmartPhone ? 'auto' : imageHeight + 'px', 'width.px' : imageWidth, 'font-size.px': imageHeight / 4 }"
          soho-context-menu
          [menu]="menuId"
          [autoFocus]="true"
          trigger="click"
          (beforeopen)="onBeforeOpen()"
          soho-alert
          soho-input-validate
          (error)="onError($event)"
          (valid)="onValid($event)">
          {{foreGroundText}}
        </span>

        @if (hasUpdateAction) {
          <ul soho-popupmenu attr.id="{{menuId}}" attr.data-automation-id="lm-{{fieldAutomationId}}-contextmenu">
            @for (menuEntry of contextEntries; track trackByMenuId(menuEntry)) {
              <li soho-popupmenu-item [isDisabled]="menuEntry.disabled">
                <a soho-popupmenu-label [id]="menuEntry.menuId" menuId="{{menuEntry.menuId}}" (click)="onImageMenuFired(menuEntry.menuId)">{{menuEntry.text}}</a>
              </li>
            }
          </ul>
        }
      } @else {
        <img #fileImage
          [attr.id]="id"
          [src]="imageUrl | async"
          class="image-auto"
          [ngStyle]="{ 'height.px': isSmartPhone ? 'auto' : imageHeight + 'px', 'width.px' : imageWidth }"
          [attr.tabindex]="0"
          [attr.aria-describedby]="fieldDescriptionId"
          soho-context-menu
          [menu]="menuId"
          [autoFocus]="true"
          trigger="click"
          (beforeopen)="onBeforeOpen()"
          soho-alert
          soho-input-validate
          (error)="onError($event)"
          (valid)="onValid($event)"
          alt="{{imageAltText}}"
          title="{{imageAltText}}"/>
          <canvas [ngStyle]="{'display':'none', 'height.px': isSmartPhone ? 'auto' : imageHeight + 'px', 'width.px' : imageWidth }" #imgCanvas></canvas>

        @if (hasUpdateAction) {
          <ul soho-popupmenu id="{{menuId}}" attr.data-automation-id="lm-{{fieldAutomationId}}-contextmenu">
            @for (menuEntry of contextEntries; track trackByMenuId(menuEntry)) {
              <li soho-popupmenu-item [isDisabled]="menuEntry.disabled">
                <a soho-popupmenu-label [id]="menuEntry.menuId" menuId="{{menuEntry.menuId}}" (click)="onImageMenuFired(menuEntry.menuId)">{{menuEntry.text}}</a>
              </li>
            }
          </ul>
        }
      }

      <input #fileInput type="file" accept="image/*" [name]="bindId" class="hideInput" (change)="onFileChanged($event)"/>
    </div>
  }
}
@if (errorLiveMessage.liveMessage) {
  <span lm-live-region [liveRegionConfig]="errorLiveMessage"></span>
}

<ng-template #mouseOverTextTemplate>
  @if (layoutObject.mouseOverText) {
          <lm-mouse-over-text
            [beforeShowTooltip]="displayMouseOverText"
          ></lm-mouse-over-text>
  }
</ng-template>

<span [attr.id]="fieldDescriptionId" class="audible">{{ (isFocused$ | async) ? fieldDescription : '' }}</span>